import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import AppHeader from 'components/AppHeader';
import MapView from 'views/MapView';

const App = () => (
  <BrowserRouter>
    <div className="app-shell">
      <AppHeader />
      <Routes>
        <Route path="/" element={<MapView />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </div>
  </BrowserRouter>
);

export default App;
